import "./css/QuestionnairesItem.css";
import React, { useEffect } from "react";
import InfoAlert from "./InfoAlert";
import Button from "./ButtonV1";
import { ArrowForward } from "@mui/icons-material";
import { Card, Box } from "@mui/material";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import TickRoundIcon from "../icons/TickRoundIcon";
import HourglassIcon from "../icons/HourglassIcon";
import StatusComponent from "../stories/StatusComponent/StatusComponent";
import { useNavigate } from "react-router-dom";
import axios from "../utils/fvAxios";
import status from "../stories/StatusComponent/status.json";
import SelectYetQues from "../icons/VendorStatusIcons/Yet to select Questionnire.svg";


function QuestionnairesItem({
  statusId,
  logo,
  title,
  submitted,
  statusPeriod,
  PreQualificationID,
  Label,
  data,
  isMultiple
}) {
  const navigate = useNavigate();
  const MoveTo = (val, event) => {
    if (val == "Select Questionnaire") {
      if (isMultiple == true) {
        axios.post("Prequalification/StartQuestionnaire?clientId=" + data?.clientId + "&vendorId=" + data?.vendorID + "&isMultiClient=true")
          .then((res) => {
            if (res?.data) {
              const serializedData = JSON.stringify(res?.data?.data?.templates);
              if (event.ctrlKey) {
                window.open("/TemplatesList?startprq=" + serializedData + "&pqid=" + PreQualificationID, '_blank');
                return;
              } else {
                navigate("/TemplatesList?startprq=" + serializedData + "&pqid=" + PreQualificationID)
              }
            }
          })
      } else {
        axios.post("Prequalification/StartQuestionnaire?clientId=" + data?.clientId + "&vendorId=" + data?.vendorID + "&isMultiClient=false")
          .then((res) => {
            if (res?.data) {
              const serializedData = JSON.stringify(res?.data?.data?.templates);
              if (event.ctrlKey) {
                window.open("/TemplatesList?startprq=" + serializedData + "&pqid=" + PreQualificationID, '_blank');
                return;
              } else {
                navigate("/TemplatesList?startprq=" + serializedData + "&pqid=" + PreQualificationID)
              }
            }
          })
      }
    } else if (val = "Complete Missing Items" || "View Prequalification") {

      if (event.ctrlKey) {
        window.open("/vendordetails?pqid=" + PreQualificationID, '_blank');
        return;
      } else {
        navigate("/vendordetails?pqid=" + PreQualificationID);
      }

    }

  }
  const Status = status?.find((r) => r?.value == statusId);
  return (
    <>
      <div className="questionnaireItem-header">
        <Box className=" text-center mt-2" sx={{ width: "150px", height: "auto", backgroundColor: Status?.color }}>
          {/* <CardContent className="text-center" sx={{ color: "#fff" }}> */}
          {[1, 2, 6, 11].includes(statusId) ? <img src={SelectYetQues} alt={Status?.key} /> : <img src={Status?.imageUri} alt={Status?.key} />}  <span style={{ color: [10, 34].includes(statusId) ? "#000" : "#fff" }} >{[1, 2, 6, 11].includes(statusId) ? Status?.key : Status?.key}</span>
          {/* </CardContent> */}
        </Box>
        {/* <StatusComponent type={statusId} /> */}
        <div >
          <img style={{ width: "100px", height: "100px", objectFit: "contain" }} src={"data:image/png;base64," + logo} alt={title} />
        </div>
      </div>
      {([3, 7].includes(statusId) && data.locked != true) && (
        <InfoAlert
          alertMessage={
            'To complete a questionnaire you\'ve already started, click on the "Complete Missing Items" link'
          }
        />
      )}
      <div className="questionnaireItem-description">
        <h6>{title}</h6>
        <p>
          Submitted: <span style={{ color: "black" }}>{submitted}</span>
        </p>
        <p>
          Status Period: <span style={{ color: "black" }}>{statusPeriod}</span>
        </p>
      </div>
      <Button
        disabled={data.locked}
        onClick={(event) => MoveTo(Label, event)}
        label={Label}
        trailingComponent={<ArrowForward style={{ border: "none" }} />}
        size="large"
        style={{
          marginTop: "10px",
          padding: "9px 14px",
          width: "100%",
          background: "#DBEAF4",
          color: "#2A93DB",
          border: "none",
        }}
      />
    </>
  );
}

export default QuestionnairesItem;
